import { Container } from "@bryntum/schedulerpro";
import { pluralize } from "../../../other/utils/otherUtils.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";

const customGrouperRenderer = ({ groupRowFor, count, isFirstColumn, record }) => {
  // groupColumn can be missing, so we cannot rely on it
  // Check group field in the group record
  if (record.meta.groupField === "status") {
    if (isFirstColumn) {
      const createMsg = `Successfully Created (${count}) ${pluralize(count, "Record")}`;
      const updateMsg = `Successfully Updated (${count}) ${pluralize(count, "Record")}`;
      const error = `❌ Error In Importing (${count}) ${pluralize(count, "Record")}`;
      const displayMsg = groupRowFor === "error" ? error: groupRowFor === "updated" ? updateMsg: createMsg;
      return `<span style="font-weight: bold">${displayMsg}</span>`;
    }
  }
};

export default class ImportFeedbackTab extends Container {
  static get $name() {
    return "ImportFeedbackTab";
  }

  static get type() {
    return "importfeedbacktab";
  }

  static get configurable() {
    return {
      title: "Import Feedback",
      items: {
        importFeedbackGrid: {
          type: WIDGET_KEYS.swivuPreferenceStyleGrid,
          height: "100%",
          emptyText: "No records were imported. The file may be empty or contain invalid data.",
          features : {
            cellEdit: false,
            sort: {multiSort: false},
            group : {
              field: "status",
              renderer: customGrouperRenderer,
            }
          },
          bbar: {
            items: [{ ref: "totalCountDisplay", type: "displayfield" }]
          },
          columns: [
            { id: "import-feedback-row-idx", field: "row_index", text: "Row #", groupable: false },
            { id: "import-feedback-status", field: "status", text: "Status", hidden: true },
            { id: "import-feedback-message", field: "message", text: "Message", groupable: false },
          ],
        }
      }
    }
  }

  editRecord(record, otherParams) {
    const { labelIndex } = otherParams;
    const { rows: data, created_count = 0, error_count = 0, updated_count = 0 } = record.importResponseData;
    const { importFeedbackGrid, totalCountDisplay } = this.widgetMap;

    // Calculate total records count
    const totalRecordsCount = created_count + error_count + updated_count;
    totalCountDisplay.value = `Total ${pluralize(totalRecordsCount, "Record")}: ${totalRecordsCount}`;

    // since bryntum create record template using the first row in the record and since
    // the response from backend is not consistent means it doesn't always include `message` field (in current case),
    // then we'll see no data in grid column for that field type, this is a workaround to this
    importFeedbackGrid.data = data.map((d) => ({
      ...d,
      message: d.message || `Successfully imported: "${d.data?.[labelIndex] || ""}"`
    }));
    importFeedbackGrid.collapseAll();
  }
}

ImportFeedbackTab.initClass();
